import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Sprout } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser, setStatus, refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/");
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    // Clean the URL immediately so a refresh can't replay the exchange.
    window.history.replaceState({}, document.title, window.location.pathname);

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        // Belt-and-suspenders: set state directly AND re-fetch /auth/me so we
        // reconcile with the httpOnly cookie the backend just set. If either
        // one fires late (React batching / StrictMode double-effect), the
        // other guarantees the Protected wrapper sees "authenticated" on the
        // very first render at /dashboard.
        setUser(data.user);
        setStatus("authenticated");
        try { await refresh(); } catch { /* state already set from POST */ }
        toast.success("Signed in with Google");
        nav("/dashboard", { replace: true });
      } catch {
        setStatus("anonymous");
        toast.error("Google sign-in failed");
        nav("/", { replace: true });
      }
    })();
  }, [nav, setUser, setStatus, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Sprout className="w-6 h-6 text-primary mx-auto animate-pulse" />
        <p className="mt-3 text-sm text-muted-foreground">Finishing sign-in…</p>
      </div>
    </div>
  );
}
